import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { MenuItem } from '@mui/material';
import { CreateFormat } from '../../../../reduxToolkit/HID/HidApi';
import CustomModal from '../../../../components/Modal/CustomModal';
import { CustomSelectAndChildren } from '../../../../components/CustomSelectAndChildren';
import { CustomTextField } from '../../../../components/CustomTextField';
import { FORMAT_DATA } from './Model/Models';
import HandleChange from '../../../../Helpers/HandleChange';
import {errorMsg} from "../../../../Apis/functions";

const CreateFormats = (props) => {
    const { controllerId, onHide, setModified } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const getFormat = useSelector((state) => state.CardsSlice.getAllCardFormats);
    const [format, setFormat] = useState({ ...FORMAT_DATA, hidId: controllerId });
    const [emptyFields, setEmptyFields] = useState(false);
    const { handleChange } = HandleChange({ model: format, setModel: setFormat });

    const handleSubmit = () => {
        if (!format.isValid()) {
            setEmptyFields(true);
            return;
        }
        const body = format.toAddEdit();
        dispatch(CreateFormat(body)).then(({ payload: { data: { data, success, code }, } }) => {
            if (success === true) {
                toast.success(t('has_been_created_successfully'));
                onHide();
                setModified(true);
                resetValues();
            } else errorMsg(code);
        },
        );
    };

    const resetValues = () => {
        setFormat({ ...FORMAT_DATA, hidId: controllerId })
    };

    return (
        <CustomModal
            title='create_format'
            size='md'
            buttonConfirm='confirm'
            {...props}
            onHide={() => {
                onHide();
                resetValues();
            }}
            onConfirm={() => {
                handleSubmit();
            }}
        >
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomSelectAndChildren
                    id={"slt_cf_format"}
                    name={"formatId"}
                    trans={"format"}
                    value={format.formatId}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    showNoSelectionOption={false}
                >
                    {getFormat.map((format) => (
                        <MenuItem key={format.id} value={format.id}>
                            {format.name}
                        </MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomTextField
                    id={"txt_cf_facility_code"}
                    trans={"facility_code"}
                    name={"facilityCode"}
                    type={"number"}
                    value={format.facilityCode}
                    onChange={handleChange}
                    required={true}
                    emptyFields={emptyFields}
                    length={3}
                />
            </div>

        </CustomModal>
    );
};

export default CreateFormats;
